import { Directive, ElementRef, EventEmitter, OnDestroy, Output, Renderer2 } from '@angular/core';

@Directive({
    selector: '[onScroll]'
})
export class OnScrollDirective implements OnDestroy {
    @Output()
    public scrolled = new EventEmitter<Event>();

    private removeScrollListenerFn: () => void;

    constructor(private renderer: Renderer2, private elementRef: ElementRef) {
        this.registerScrollListener();
    }

    private registerScrollListener(): void {
        this.removeScrollListenerFn = this.renderer.listen(this.elementRef.nativeElement, 'scroll', (event: Event) => {
            this.scrolled.emit(event);
        });
    }

    ngOnDestroy(): void {
        if (this.removeScrollListenerFn) {
            this.removeScrollListenerFn(); // Remove the scroll listener
        }
    }
}
